import React, {useRef, useEffect, useState, useContext} from 'react';
import mapboxgl from '!mapbox-gl'; // eslint-disable-line import/no-webpack-loader-syntax
import {accessToken} from "./tokens";
import unitedStatesMap from './images/united states map.jpeg'
import TripModal from "./TripModal";
import TripPicturesSlideshow from "./TripPicturesSlideshow";
import axios from "axios";
import {UserContext} from "./UserContext";
import {getBearerToken, getServerUrl} from "./utils/utils";
import {useParams} from "react-router-dom";


function AllTripsMap({locations, onMarkerEvent, locationsClickedStatus, location, includeZoom = false, initialZoomLevel, onTripsPage, retrievingLocations, viewingMultipleTrips, fullscreen, zoomInOnTrips = true, rankingTrips, startPictureSlideShow}) {
    const {id} = useParams()
    const {user} = useContext(UserContext)
    mapboxgl.accessToken = accessToken;
    const mapContainer = useRef(null);
    const map = useRef(null);
    const [lng, setLng] = useState(-50);
    const [lat, setLat] = useState(35);
    const [locationMarkersObj, setLocationMarkersObj] = useState({})
    const [globalTimeout, setGlobalTimeout] = useState(null)
    const [locationCoordinateList, setLocationCoordinateList] = useState([])
    const [zoom, setZoom] = useState(2)
    const [lastTimeout, setLastTimeout] = useState(null)
    const [currentLocations, setCurrentLocations] = useState([])
    const pixelWidthOfPage = onTripsPage ? document.getElementById('allTripsMap')?.clientWidth : document.getElementById('viewTripMap')?.clientWidth
    const pixelHeightOfPage = onTripsPage ? document.getElementById('allTripsMap')?.clientWidth : document.getElementById('viewTripMap')?.clientHeight
    const [coverImage, setCoverImage] = useState(false)
    const [imageFadeDone, setImageFadeDone] = useState(true)
    const [fullscreenLocation, setFullscreenLocation] = useState(false)
    const [openPictureSlideshow, setOpenPictureSlideshow] = useState(startPictureSlideShow)
    const [trips, setTrips] = useState([])
    const [currentRankingTrips, setCurrentRankingTrips] = useState([])

    const addMarkersToLocations = (locations, markersObj, locationCoordinates, addRankingMarkerOnly = false) => {
        locations?.forEach((activityLocation, index) => {
            if (activityLocation) {
                fetch(`https://api.mapbox.com/geocoding/v5/mapbox.places/${activityLocation}.json?access_token=${accessToken}`)
                    .then(response => response.json())
                    .then(data => {
                        if (data.features) {
                            const coordinates = {
                                lng: data.features[0].center[0],
                                lat: data.features[0].center[1]
                            }
                            locationCoordinates.push(coordinates)
                            if (index === (locations.length - 1)) {
                                setLocationCoordinateList(locationCoordinates)
                            }

                            const matchingRankingTrip = rankingTrips?.find(rankingTrip => {
                                return rankingTrip.location === activityLocation;
                            })
                            if (matchingRankingTrip && !markersObj[`${activityLocation}-ranking`]) {
                                var el = document.createElement('div');
                                el.className = 'marker rankingMarker';
                                el.innerHTML = '<span><b>' + (matchingRankingTrip?.listNumber) + '</b></span>'
                                const marker = new mapboxgl.Marker(el)
                                    .setLngLat(coordinates)
                                    .addTo(map.current);
                                markersObj[`${activityLocation}-ranking`] = marker
                                addListenersToMarker(marker, activityLocation)
                            }
                            if (!addRankingMarkerOnly) {
                                const marker = new mapboxgl.Marker({
                                    scale: onTripsPage ? (fullscreen ? 0.75 : 0.5) : 1.0,
                                    color: fullscreen ? 'black' : '#3FB1CE'
                                })
                                    .setLngLat(coordinates)
                                    .addTo(map.current);
                                addListenersToMarker(marker, activityLocation)
                                markersObj[activityLocation] = marker
                            }
                        }
                    })
            }
        })
        setLocationMarkersObj(markersObj)
    }

    useEffect(() => {
        if (location && !fullscreen) {
            if (globalTimeout) {
                clearTimeout(globalTimeout);
            }
            let updatedTimeout = setTimeout(function () {
                flyToLocation(location)
            }, 500)
            setGlobalTimeout(updatedTimeout)
        }
    }, [location])

    useEffect(() => {
        if (Object.keys(locationMarkersObj).length > 0 && currentRankingTrips?.length > 0 && (rankingTrips?.length !== currentRankingTrips?.length ||
            rankingTrips?.filter(rankingTrip => !currentRankingTrips.map(currentRankingTrip => currentRankingTrip.id).includes(rankingTrip.id))?.length > 0)) {
            currentRankingTrips.forEach(rankingTrip => {
                const currentRankingMarker = locationMarkersObj[`${rankingTrip.location}-ranking`]
                    if (currentRankingMarker){
                        currentRankingMarker.remove()
                        locationMarkersObj[`${rankingTrip.location}-ranking`] = null
                    }
            })
            addMarkersToLocations(rankingTrips?.map(rankingTrip => rankingTrip.location), locationMarkersObj, locationCoordinateList, true)
            setCurrentRankingTrips(rankingTrips)
        } else if (rankingTrips?.length > 0 && !currentRankingTrips?.length > 0 && Object.keys(locationMarkersObj).length > 0) {
            setCurrentRankingTrips(rankingTrips)
            addMarkersToLocations(rankingTrips?.map(rankingTrip => rankingTrip.location), locationMarkersObj, locationCoordinateList, true)
        }
    }, [rankingTrips, currentRankingTrips, locationMarkersObj, locationCoordinateList])

    const fetchTrips = async () => {
        axios.get(`${getServerUrl()}/user/${user?.id}/trip`, {
            headers: {Authorization: `Bearer ${await getBearerToken()}`}
        })
            .then(response => {
                const shuffledTrips = response.data
                    .map(value => ({value, sort: Math.random()}))
                    .sort((a, b) => a.sort - b.sort)
                    .map(({value}) => value)
                setTrips(shuffledTrips)
            })
    }

    useEffect(() => {
        if (fullscreen && !trips.length > 0) {
            fetchTrips()
        }

    }, [fullscreen])


    useEffect(() => {
        if (currentLocations) {
            currentLocations.forEach(location => {
                const marker = locationMarkersObj[location]
                if (marker) {
                    let markerElement = marker.getElement();
                    let markerFill
                    if (locationsClickedStatus[location]) {
                        markerFill = '#FF0000'
                    } else {
                        markerFill = fullscreen ? 'black' : '#3FB1CE'
                    }
                    markerElement
                        .querySelectorAll('path')[0]
                        .setAttribute("fill", markerFill)
                }
            })
        }
    }, [locationsClickedStatus, locationMarkersObj, currentLocations])

    useEffect(() => {
        console.log("adding markers now that we are fullscreen")
        if (locations.length > 0 && (locations.filter(currentLocation => !currentLocations.includes(currentLocation)).length > 0 || (locations?.length === 1 && currentLocations?.length > 1))) {
            const locationsObj = {}
            const uniqueLocations = locations.filter(location => {
                if (locationsObj[location]) {
                    return false
                } else {
                    locationsObj[location] = true
                    return true
                }
            })
            setCurrentLocations(uniqueLocations)
            console.log(uniqueLocations)
            for (const locationMarker in locationMarkersObj) {
                locationMarkersObj[locationMarker].remove()
            }
            const markersObj = {}
            const locationCoordinates = []
            addMarkersToLocations(uniqueLocations, markersObj, locationCoordinates)
        }
    }, [locations, locationMarkersObj, currentLocations])

    useEffect(() => {
        if (fullscreen) {
            setCurrentLocations([])
        }
    }, [fullscreen])


    useEffect(() => {
        if (includeZoom && locationCoordinateList && lng && lat && !fullscreen) {
            clearTimeout(lastTimeout)
            const timeout = setTimeout(() => {
                if (viewingMultipleTrips && zoomInOnTrips) {
                    const newCenterCoordinates = setNewMapCenter()
                    if (newCenterCoordinates) {
                        getZoom(newCenterCoordinates)
                    }
                } else {
                    getZoom()
                }
            }, 1000)
            setLastTimeout(timeout)
        }
    }, [locationCoordinateList, pixelWidthOfPage, lng, lat, retrievingLocations])

    const setNewMapCenter = () => {
        const locationCoordinateListFiltered = locationCoordinateList.filter(coordinate => coordinate?.lat && coordinate?.lng)
        if (locationCoordinateListFiltered?.length > 0) {
            let middleLat = (Math.min(...locationCoordinateListFiltered.map(coordinate => coordinate.lat)) + Math.max(...locationCoordinateListFiltered.map(coordinate => coordinate.lat))) / 2
            let middleLng = (Math.min(...locationCoordinateListFiltered.map(coordinate => coordinate.lng)) + Math.max(...locationCoordinateListFiltered.map(coordinate => coordinate.lng))) / 2
            // locationCoordinateList.forEach(coordinates => {
            //     totalLat += coordinates.lat
            //     totalLng += coordinates.lng
            // })
            // const newCenterCoordinates = {
            //     lng: totalLng/locationCoordinateList.length,
            //     lat: totalLat/locationCoordinateList.length
            // }
            const newCenterCoordinates = {
                lat: middleLat,
                lng: middleLng
            }
            map.current.flyTo({
                center: newCenterCoordinates,
                animate: true,
                duration: 1000
            });
            return newCenterCoordinates
        }
    }

    const getZoom = (newCenterCoordinates = null) => {
        if (pixelWidthOfPage) {
            console.log("pixelWidthOfPage", pixelHeightOfPage)
            const zoom15 = 2.389
            const zoomMap = {
                15: zoom15
            }
            for (let i = 14; i >= 0; i--) {
                zoomMap[i] = zoom15 * Math.pow(2, (15 - i))
            }
            const latLngDistanceFromCenterList = locationCoordinateList.map(coordinate => {
                return {
                    lng: Math.abs(Math.abs(coordinate.lng) - Math.abs(newCenterCoordinates ? newCenterCoordinates.lng : lng)),
                    lat: Math.abs(Math.abs(coordinate.lat) - Math.abs(newCenterCoordinates ? newCenterCoordinates.lat : lat))
                }
            })
            const zoomArray = latLngDistanceFromCenterList.map(coordinateDistance => {
                const latDistanceInMeters = coordinateDistance.lat * 111139
                const lngDistanceInMeters = coordinateDistance.lng * 111139
                for (let i = 15; i > 0; i--) {
                    let zoomWidthInMeters = (zoomMap[i] * pixelWidthOfPage) / 2
                    let zoomHeightInMeters = (zoomMap[i] * pixelHeightOfPage) / 2
                    // const latDifference = zoomWidthInMeters - lngDistanceInMeters
                    // const lngDifference = zoomHeightInMeters - lngDistanceInMeters
                    // let zoomWidthInMetersPreviousZoom = (zoomMap[i + 1] * pixelWidthOfPage)
                    // let zoomHeightInMetersPreviousZoom = (zoomMap[i + 1] * pixelHeightOfPage)
                    // const latDifferenceBetweenZooms = (latDifference/zoomHeightInMetersPreviousZoom)
                    // const lngDifferenceBetweenZooms = (lngDifference/zoomWidthInMetersPreviousZoom)
                    if (lngDistanceInMeters < zoomWidthInMeters && latDistanceInMeters < zoomHeightInMeters) {
                        // return i + Math.min(lngDifferenceBetweenZooms, latDifferenceBetweenZooms)
                        return i;
                    }
                }
            })
            if (zoomArray?.length > 0 && !retrievingLocations) {
                const zoomLevel = Math.min(...zoomArray.filter(zoomNum => zoomNum))
                // const newZoom = newCenterCoordinates ? zoomLevel - 1 : zoomLevel
                if (zoom !== zoomLevel) {
                    console.log("zoom: " + zoomLevel)
                    if (zoomInOnTrips) {
                        setZoom(zoomLevel)
                        setTimeout(() => {
                            map.current.zoomTo(zoomLevel - 1 , {duration: 1000, animate: true})
                        }, 500)
                    }
                }
            }
        }
    }

    function addListenersToMarker(marker, location) {
        const markerDiv = marker.getElement();
        markerDiv.addEventListener('click', () => {
            onMarkerEvent(location, locationMarkersObj, locations)
            setFullscreenLocation(currentFullscreenLocation => {
                if (currentFullscreenLocation === location) {
                    return null
                } else {
                    return location
                }
            })

        })

    }

    const flyToLocation = (selectedLocation, duration = 1000) => {
        fetch(`https://api.mapbox.com/geocoding/v5/mapbox.places/${selectedLocation}.json?access_token=${accessToken}`)
            .then(response => response.json())
            .then(data => {
                if (data.features) {
                    setLng(data.features[0].center[0])
                    setLat(data.features[0].center[1])
                    map.current.flyTo({
                        center: {
                            lng: data.features[0].center[0],
                            lat: data.features[0].center[1]
                        },
                        duration: duration,
                        animate: true,
                        zoom: 10
                    });
                }
            })
    }


    useEffect(() => {
        if (map.current) return;
        const zoom = fullscreen ? 3 : initialZoomLevel
        console.log(zoom)
        map.current = new mapboxgl.Map({
            container: mapContainer.current,
            style: 'mapbox://styles/mapbox/streets-v11',
            center: fullscreen ? [-96.486, 38.424] : [lng, lat],
            zoom: zoom,
            projection: fullscreen ? 'globe' : null
        });
    });

    return (
        <div id={onTripsPage ? 'allTripsMap' : 'viewTripMap'}>
            {fullscreen && (
                <div
                    id="fullscreen-map-image"
                    style={coverImage ? {opacity: 1} : imageFadeDone ? {display: 'none'} : {opacity: 0}}
                    onClick={() => {
                        setTimeout(() => {
                            setImageFadeDone(true)
                        }, [3000])
                        setCoverImage(false)
                    }}
                >
                    <img src={unitedStatesMap}/>
                </div>
            )}
            {(fullscreen && !coverImage) && (
                    <button
                        className="ui button"
                        id="start-slideshow-button"
                        type='button'
                        onClick={() => setOpenPictureSlideshow(!openPictureSlideshow)}
                    >
                        {openPictureSlideshow ? 'End Slideshow' : 'Start Slideshow'}
                    </button>

            )}
            <TripModal
                location={fullscreenLocation}
                fullscreen={fullscreen}
                endpoint={`/user/${id || user?.id}/trip/location/`}
                onClose={() => {
                        const marker = locationMarkersObj[fullscreenLocation]
                        let markerElement = marker?.getElement();
                        if (markerElement) {
                            const markerElements = markerElement.children[0].children
                            for (let i = 0; i < markerElements.length - 1; i++) {
                                const markerSvgElement = markerElements[i]
                                markerSvgElement.setAttribute("fill", "black");
                            }
                        }

                        // marker._color = color;
                    setFullscreenLocation(null)
                }}
            />
            <TripPicturesSlideshow
                trips={trips}
                open={openPictureSlideshow}
                onLocationSelect={slideshowLocation => flyToLocation(slideshowLocation, 8000)}
            />
            <div ref={mapContainer} className="map-container" style={fullscreen ? {height: '100vh'} : {}}/>
        </div>
    );
}

export default AllTripsMap;